export default __webpack_public_path__ + "static/EnhanceWallet-83f9aec7a0736652eb59f083fce418be.png";